import { render, staticRenderFns } from "./NewsDetailsTen.vue?vue&type=template&id=ab3cad20"
import script from "./NewsDetailsTen.vue?vue&type=script&lang=js"
export * from "./NewsDetailsTen.vue?vue&type=script&lang=js"
import style0 from "./NewsDetailsTen.vue?vue&type=style&index=0&id=ab3cad20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports